<template>
  <div class="article-view-page-wrapper">
    <div class="content-wrapper app-bg-white">
      <div class="main-content">
        <BaseLoading v-if="loading"></BaseLoading>
        <p v-else-if="noAuth" class="no-auth-wrapper">
          您暂无权限查看详细信息~
        </p>
        <div v-else-if="!articleInfo" class="empty-wrapper">
          <img :src="siteEmptyImg" />
          <p>暂时无法查看详细信息~</p>
        </div>
        <template v-else>
          <p v-if="isPreview" class="preview-wrapper">该页面为预览页面!!!</p>
          <DetailArticle
            :article="articleInfo"
            :is-internal="isInternal"
            :pkg="pkg"
          ></DetailArticle>
          <WeiboCard v-if="!isInternal"></WeiboCard>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import siteEmptyImg from '@/assets/img/common/site-empty-search.png'
import { constants } from '@/global'
import DetailArticle from './components/DetailArticle'
import WeiboCard from './components/WeiboCard'
import { THIRD_API } from '@/global/config'

const { ERROR_CODE } = constants

export default {
  metaInfo() {
    const { articleInfo } = this
    if (!articleInfo) {
      return {}
    }
    const { description, title } = this.articleInfo
    const keywords = this.articleInfo.keywords
      ? `${this.articleInfo.keywords},${title}`
      : ''
    return {
      title,
      titleTemplate: '%s - 社会化营销案例库',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: description
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: keywords
        }
      ]
    }
  },
  components: {
    DetailArticle,
    WeiboCard
  },
  props: {
    id: {
      type: String,
      required: true
    },
    isPreview: Boolean,
    isInternal: Boolean
  },
  data() {
    return {
      loading: true,
      noAuth: false,
      articleInfo: null,
      pkg: {
        type: this.isInternal ? 'document' : 'article',
        id: this.id
      },
      siteEmptyImg,
      articleCategory: []
    }
  },
  created() {
    this.getArticleInfo()
    this.getCategoryList()
  },
  methods: {
    async getArticleInfo() {
      try {
        const { isInternal, isPreview } = this
        const res = await this.$http.get(
          THIRD_API.alkArticleDetail.link,
          {
            params: {
              id: this.id,
              preview: this.isPreview ? 1 : 0
            }
          },
          true
        )
        this.loading = false
        this.articleInfo = res.data
        let key = isInternal ? 'iarticle' : 'article'
        key += isPreview ? '_preview' : '_view'
        this.$stat({
          key: key + '_pshow',
          params: {
            o: this.id,
            module: (this.articleInfo.type || {}).name
          }
        })
      } catch (e) {
        this.loading = false
        this.handleError(e)
      }
    },
    async getCategoryList() {
      try {
        const res = await this.$http.get(
          THIRD_API.alkArticleCategoryList.link,
          {},
          true
        )
        this.articleCategory = res.data
      } catch (e) {
        this.handleError(e)
      }
    },
    handleError(e) {
      if (e) {
        const { errno } = e
        if (errno - 0 === ERROR_CODE.NO_PERMISSION) {
          this.noAuth = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.article-view-page-wrapper {
  padding: 67px 0 88px;
}
.content-wrapper {
  background-color: #ffffff;
  padding: 48px 0 108px;
}
.main-content {
  width: 984px;
  margin: 0 auto;
}
.no-auth-wrapper {
  margin: 0 auto;
  padding: 100px 0;
  color: #4a4a4a;
  font-size: 13px;
  text-align: center;
}
.empty-wrapper {
  padding: 100px 0;
  color: #aaaaaa;
  font-size: 14px;
  text-align: center;
  img {
    width: 185px;
    height: 170px;
    margin-bottom: 36px;
  }
}
.preview-wrapper {
  background-color: #ff0000;
  color: #ffff00;
  font-size: 42px;
  text-align: center;
  line-height: 120px;
  margin: -30px 0 30px;
}
</style>
